import * as React from 'react';

import { useFiltersContext } from '../../../../packages/Filters/shared/utils/useFiltersContext';
import { getRangeValue } from '../../../../packages/JsonQuery';
import { getNormalizedValue } from '../../../common/utils/getNormalizedValue';
import { Filter } from '../../components/Filter';
import { GuestsCountInput } from '../../components/GuestsCountInput/GuestsCountInput';
import { DEFAULT_VALUE, MAX_VALUE, MIN_VALUE } from '../GuestsChipContainer/constants';

export const GuestsCountContainer = () => {
  const { jsonQuery, onChange } = useFiltersContext();
  const bedrooms = getRangeValue('beds_count')(jsonQuery);

  const handleChange = React.useCallback(
    (value: number) => {
      const gte = value;
      const lte = null;
      onChange({ action: 'setBeds', arguments: [gte > 1 ? gte : null, lte] });
    },
    [onChange],
  );

  const value = getNormalizedValue(bedrooms?.gte, MIN_VALUE, MAX_VALUE) || DEFAULT_VALUE;

  return (
    <Filter id="filter_guests" contentPadding={false}>
      <GuestsCountInput value={value} onChange={handleChange} min={MIN_VALUE} max={MAX_VALUE} />
    </Filter>
  );
};
